import React from 'react'

const PL9BeerMenuBoard = (props) => {

    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items
    let layout = props.layout

    let tapsColOne = tapBeers.slice(0, 12)
    let tapsColTwo = tapBeers.slice(12)

    const getLayOut = (layout) => {
        if (layout === "horizontal") {
            return (
                <div className="tap-beer-background">
                <div className="menu-board-row">
                    <div className="column menu-board-taps-left">
                        <div className="white taps-left-col hor">
                            {tapsColOne.map(item => (
                                <div className="pl5-taps-item taps-cans-tap menu-board-item pl9 taps">
                                    {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}%
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="column menu-board-taps-right">
                        <div className="row">
                            <div className="white taps-right-col col2-taps">
                                {tapsColTwo.map(item => (
                                    <div className="pl5-taps-item taps-cans-tap menu-board-item pl9 taps-col-2">
                                        {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}%
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row">
                            <div className="bottles-cans-header">
                                Bottles and Cans
                            </div>
                            <div className="white taps-right-col">
                                {canBeers.map(item => (
                                    <div className="pl5-taps-item taps-cans-tap menu-board-item pl9 col2-bottles-cans ">
                                        {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style taps-cans">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}%
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
        } else if (layout === "vertical") {
            return (
                <div className="menu-board-tap-beer-cans-vertical-background vertical">
                    <div className="menu-board-row vert">
                        <div className="column menu-board-taps-left vert-taps">
                            <div className="white taps-left-col ">
                                {tapBeers.map(item => (
                                    <div className=" menu-board-item pl9 taps black-text vert-tap-item">
                                        {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style-vert">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}%
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            {getLayOut(layout)}
        </>
    )
}
export default PL9BeerMenuBoard